import permissions from './../../data/permissions'
export default [
    {
        name: "Receipts",
        path: "receipts",
        component: () => import("./../../views/warehouse/ReceiptsListView.vue"),
        meta: { requiresAuth: true, authorization: permissions.po_good_receipt.index }
    },
    {
        name: "ReceiptDisplay",
        path: "receipt/:id",
        component: () => import('./../../views/purchase/GoodReceiptDisplayView.vue'),
        meta: { requiresAuth: true, authorization: permissions.po_good_receipt.read }
    },
    {
        name: "ReceiptCreate",
        path: "receiptCreate",
        component: () => import('./../../views/warehouse/GoodReceiptCreateView.vue'),
        meta: { requiresAuth: true, authorization: permissions.po_good_receipt.create }
    },
]